import { EnvironmentModel } from "./environment-model.interface";

export const environment: EnvironmentModel = {
  production: true,
  apiUrl: 'https://api.flirtext.com',
  buildVersion: 'legal'
};
